import axios, { AxiosResponse } from 'axios';
import { err } from '../utils';

const URL = '/api/error';

const recordError = async (token: string, msg: string): Promise<void> => {
  try {
    const res: AxiosResponse<Record<string, unknown>> = await axios.post(
      `${URL}`,
      { msg },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }
    return;
  } catch (e) {
    console.error(e);
    throw err.handleError(e, 'error recording client error to backend');
  }
};

export default {
  recordError,
};
